import {Component, Injector} from '@angular/core';
import {CategoryState, Store as CategoryStore} from './state/store';
import {Category} from './state/model';
import {CategoryService as CategoryService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {CategoryQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class CategoryDetailComponent extends EntityDetailComponent<Category, CategoryState, CategoryStore> {

  constructor(
    public injector: Injector,
    service: CategoryService,
    protected query: CategoryQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
